<div
  class="justify-start-safe flex flex-row items-center gap-4 max-lg:flex-col"
>
  <div class="flex gap-4">
    <div
      class="relative size-[48px] rounded-full"
      id="chosen-color"
      [style.backgroundColor]="colorHexValue"
    >
      <input
        class="absolute inset-0 size-full cursor-pointer rounded-full opacity-0"
        type="color"
        #colorPicker
        [(ngModel)]="colorHexValue"
        (ngModelChange)="onColorPickerChange($event)"
      />
    </div>
    <div class="relative">
      <div
        class="!inline-flex h-[44px] w-[132px] items-center rounded-md border border-grey-midGrey px-2"
        [ngClass]="{ 'border-2 border-red-500': isHexInvalid }"
      >
        <span class="text-dark-grey select-none">#</span>
        <input
          class="size-full border-none outline-none"
          type="text"
          minlength="6"
          maxlength="6"
          [(ngModel)]="textHexValue"
          (input)="onHexInput($event)"
          (blur)="updateColorPicker(textHexValue)"
        />
      </div>
      <div
        class="pointer-events-auto absolute right-2 top-1/2 ml-2"
        [matTooltip]="tooltip()"
        matTooltipPosition="above"
        matTooltipShowDelay="500"
        matTooltipClass="custom-tooltip"
      >
        <mat-icon
          class="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-blue duration-200 hover:opacity-70"
          [class.pipette-active]="isPipetteActive"
          (click)="togglePipette()"
          >colorize</mat-icon
        >
      </div>
    </div>
  </div>
  @if (isHexInvalid) {
    <div class="flex w-52 text-xs text-red-500" *transloco="let t">
      <mat-icon
        class="material-icons-outlined text-red !inline-flex place-content-center text-xs"
        >warning</mat-icon
      >
      {{ t('portal.courseSettings.generalSettings.noValidHexCode') }}
    </div>
  }
</div>
